import {PollAdminControl} from './PollAdminControl.js';
import {PollRobotTemplate} from './PollRobotTemplate.js';

export class PollFolderItem {
	constructor(parent, item) {
		[this.el, this.$] = PollRobotTemplate(`PollFolderItem`);
		this.$.title.innerText = item.title;
		this.el.addEventListener(`click`, evt=>{
			evt.stopPropagation(); evt.preventDefault();
			parent.dispatchEvent(PollAdminControl.PollEditStartEvent(item));
		});
		parent.appendChild(this.el);
	}
}